import ECommerceContainer from "../../../../Components/General/Dashboard/ECommerce/ECommerceContainer";

const ECommerce = () => {
  return <ECommerceContainer />;
};

export default ECommerce;
